import * as React from 'react';
import { useRef } from 'react';
import lowerCase from 'lodash/lowerCase';

import { CountBadge, Pluralize, Tooltip } from 'components/common';
import useEntityCollectionStatus from 'collections/hooks/useEntityCollectionStatus';
import { createGRN } from 'logic/permissions/GRN';

type Props = {
  entityId: string;
  entityType: string;
};

const EntityCollectionTableCell = ({ entityId, entityType }: Props) => {
  const entityGRN = createGRN(entityType, entityId);
  const { data, isFetching, isError } = useEntityCollectionStatus(entityGRN, entityId);
  const count = data?.length || 0;
  const isDisabled = count === 0;
  const buttonRef = useRef();

  if (isFetching || isError) {
    return null;
  }

  const label = (
    <span>
      This {lowerCase(entityType)} is in {count} <Pluralize value={count} plural="collections" singular="collection" />.
    </span>
  );

  return (
    <td>
      <Tooltip withArrow position="right" label={label} disabled={isDisabled}>
        <CountBadge ref={buttonRef} count={count} />
      </Tooltip>
    </td>
  );
};

export default EntityCollectionTableCell;
